module.exports = __webpack_public_path__ + "img/sign_signature.d4f1ca32.png";